import React from "react";
import { useTenantContent } from "../../Context/TenantContentContext";

const Enamad = () => {
  const { content } = useTenantContent();
  const id = (content?.enamadId || "").trim();
  const code = (content?.enamadCode || "").trim();

  if (!id || !code) {
    return null;
  }

  const query = `id=${encodeURIComponent(id)}&Code=${encodeURIComponent(code)}`;

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      referrerPolicy="origin"
      target="_blank"
      rel="noopener"
      href={`https://trustseal.enamad.ir/?${query}`}
    >
      <img
        referrerPolicy="origin"
        src={`https://trustseal.enamad.ir/logo.aspx?${query}`}
        alt="نماد اعتماد الکترونیکی"
        style={{ cursor: "pointer" }}
        code={code}
      />
    </a>
  );
};

export default Enamad;
